import { Component, inject, EventEmitter, Output } from '@angular/core';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { InputFieldComponent } from '../../ui/inputField/inputField.component';
import { CustomizableButtonComponent } from '../../ui/customizable-button/customizable-button.component';
import { countries } from '../../../../utils/countriesList';
import { IOrganization } from '../../../types/contactModule';
import { industries } from '../../../../utils/staticData';
import { ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { humanizeEnum } from '../../tables/group-table/group-rows';

@Component({
  selector: 'create-organization-form',
  standalone: true,
  imports: [ModalFormContainerComponent, InputFieldComponent, CustomizableButtonComponent, ReactiveFormsModule],
  templateUrl: './create-organization-form-modal.component.html',
  styleUrls: ['../../tables/group-table/group-form.css', './create-organization-form-modal.component.css'],
})
export class CreateOrganizationFormComponent {
  @Output() closeModal = new EventEmitter();

  // static data
  countries = countries;
  industries = industries.map((industry) => ({ value: industry.value, label: humanizeEnum(industry.value) }));

  // reactive data
  submitted: boolean = false;
  saveError = '';

  // services
  contactsService = inject(ContactsService);
  builder = inject(FormBuilder);

  organizationForm = this.builder.group({
    name: ['', Validators.required],
    description: [''],
    country: ['', Validators.required],
    city: ['', Validators.required],
    region: ['', Validators.required],
    industry: ['', Validators.required],
  });

  getFormInput(name: keyof IOrganization) {
    return this.organizationForm.get(name);
  }

  close() {
    this.closeModal.emit();
  }

  get contactServiceLoading() {
    return this.contactsService.isLoading;
  }

  handleSubmit() {
    this.submitted = true;
    this.saveError = '';
    if (this.organizationForm.valid) {
      this.contactsService.createOrganization(this.organizationForm.value as IOrganization).subscribe({
        next: () => {
          this.close();
        },
        error: () => {
          this.saveError = 'The organization was not created. Check your connection and try again.';
        },
      });
    }
  }
}
